// src/modules/menu/services/guestMenuService.js
import { buildApiUrl } from '../../../config/api';

export const guestMenuService = {
    /**
     * Generar menú para invitados
     */
    async generateMenu(preferences) {
        const response = await fetch(buildApiUrl('/api/guest/generate-menu'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(preferences),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Error al generar el menú');
        }

        return await response.json();
    },

    /**
     * Obtener estado de menús para invitados
     */
    async getMenuStatus() {
        const response = await fetch(buildApiUrl('/api/guest/menu-status'), {
            method: 'GET',
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error('Error al obtener el estado de los menús');
        }

        return await response.json();
    },

    /**
     * Login para invitados
     */
    async login(email, password) {
        const response = await fetch(buildApiUrl('/api/login'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ email, password }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Error al iniciar sesión');
        }

        return await response.json();
    },

    /**
     * Registro para invitados
     */
    async register(email, password, invitation_code, stripe_session_id = null) {
        const body = { email, password, invitation_code };

        // Si hay session_id de Stripe, incluirlo para verificación
        if (stripe_session_id) {
            body.stripe_session_id = stripe_session_id;
        }

        const response = await fetch(buildApiUrl('/api/guest/register'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error al crear la cuenta');
        }

        return await response.json();
    }
};
